




























































































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { State, Mutation, Getter } from 'vuex-class';
import { IGame } from '~/store/games/types';
import {
  IGalaStoreFilterOptions,
  GalaStoreToggleFilterCategory,
  IToggleFilter,
  IStoreTokenPrice,
} from '~/types/gala-store';

@Component
export default class StoreFilters extends Vue {
  @Getter('inventoryIconForCollectionName', { namespace: 'cmsContent' })
  collectionIcons!: Record<string, string | undefined>;

  @Prop(Object) readonly options!: IGalaStoreFilterOptions;
  @Prop(Array) readonly usdPricesInCents!: number[];
  @Prop(Object) readonly tokenPrice!: IStoreTokenPrice;
  @Prop(String) readonly selectedCurrency!: string;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  panel = [0, 1, 2, 3, 4];
  priceRange = [0, 0];

  get priceFilterMin() {
    return (
      this.usdPricesInCents[this.priceRange[0]] /
      this.tokenPrice.tokenPriceInCents
    );
  }

  get priceFilterMax() {
    return (
      this.usdPricesInCents[this.priceRange[1]] /
      this.tokenPrice.tokenPriceInCents
    );
  }

  get filterCategories() {
    const options = { ...this.options };
    if (this.hideGameFilters) {
      delete options.games;
    }

    if (
      (options.price &&
        this.usdPricesInCents[0] ===
          this.usdPricesInCents[this.usdPricesInCents.length - 1]) ||
      this.tokenPrice === null
    ) {
      delete options.price;
    }

    return Object.entries(options);
  }

  get hideGameFilters() {
    return this.$route?.name === 'games-name';
  }

  checkIfOpen(index: number) {
    return this.panel.includes(index);
  }

  getPriceFormatString(price: string) {
    const highPrice = +price >= 1000000;
    let baseString = '0,0';

    if (this.selectedCurrency !== 'GALA' || highPrice) {
      baseString += '[.]0[00]';
    }
    if (highPrice) {
      baseString += ' a';
    }

    return baseString;
  }

  handleRangeChange(range: number[]) {
    // the range are the indices of values to pull from the prices array
    const [selectedMinIndex, selectedMaxIndex] = range;

    this.handleToggleFilterChange({
      type: GalaStoreToggleFilterCategory.price,
      name: 'minimum',
      selected: true,
      value: this.usdPricesInCents[selectedMinIndex],
    });

    this.handleToggleFilterChange({
      type: GalaStoreToggleFilterCategory.price,
      name: 'maximum',
      selected: true,
      value: this.usdPricesInCents[selectedMaxIndex],
    });
  }

  @Emit('toggle-filter-change')
  handleToggleFilterChange(update: {
    type: GalaStoreToggleFilterCategory;
    name: string;
    selected: boolean;
    value?: number | string;
  }) {
    return update;
  }

  @Watch('usdPricesInCents', { immediate: true })
  initializePriceRange(prices: number[]) {
    if (prices && prices.length) {
      this.priceRange = [0, prices.length - 1];
    }
  }

  @Watch('options.price', { deep: true, immediate: false })
  handlePriceRangeReset(priceFilters: IToggleFilter) {
    const [minFilter, maxFilter] = priceFilters.values;
    const updatedPriceRange = [...this.priceRange];

    if (minFilter && !minFilter.selected) {
      updatedPriceRange[0] = 0;
    }
    if (this.usdPricesInCents.length && maxFilter && !maxFilter.selected) {
      updatedPriceRange[1] = this.usdPricesInCents.length - 1;
    }

    this.priceRange = updatedPriceRange;
  }
}
